var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#8247E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5007 11.2789C18.1808 11.1128 17.7696 11.1128 17.404 11.2789L14.8453 12.6499L13.109 13.5223L10.596 14.8932C10.2761 15.0593 9.86488 15.0593 9.49935 14.8932L7.5346 13.8131C7.21475 13.6469 6.98629 13.3145 6.98629 12.9407V10.8635C6.98629 10.5312 7.16906 10.1988 7.5346 9.9911L9.49935 8.95252C9.81919 8.78635 10.2304 8.78635 10.596 8.95252L12.5607 10.0326C12.8805 10.1988 13.109 10.5312 13.109 10.905V12.276L14.8453 11.362V9.94955C14.8453 9.61721 14.6625 9.28487 14.297 9.07715L10.6416 7.12463C10.3218 6.95846 9.91057 6.95846 9.54504 7.12463L5.7983 9.11869C5.43277 9.28487 5.25 9.61721 5.25 9.94955V13.8546C5.25 14.1869 5.43277 14.5193 5.7983 14.727L9.49935 16.6795C9.81919 16.8457 10.2304 16.8457 10.596 16.6795L13.109 15.3501L14.8453 14.4362L17.3584 13.1068C17.6782 12.9407 18.0894 12.9407 18.455 13.1068L20.4197 14.1454C20.7396 14.3116 20.968 14.6439 20.968 15.0178V17.095C20.968 17.4273 20.7852 17.7596 20.4197 17.9674L18.5007 19.0059C18.1808 19.1721 17.7696 19.1721 17.404 19.0059L15.4393 17.9674C15.1195 17.8012 14.891 17.4688 14.891 17.095V15.7656L13.1547 16.6795V18.0504C13.1547 18.3828 13.3375 18.7151 13.703 18.9228L17.404 20.8754C17.7239 21.0415 18.1351 21.0415 18.5007 20.8754L22.2017 18.9228C22.5215 18.7567 22.75 18.4243 22.75 18.0504V14.1039C22.75 13.7715 22.5672 13.4392 22.2017 13.2315L18.5007 11.2789Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon);
export default __webpack_public_path__ + "static/media/polygon.4193869144f224c2b7923ae6b05649cc.svg";
export { ForwardRef as ReactComponent };